/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Ref_IntroInputs */

const en_to_csv_ref_intro = /** @type {(inputs: To_Csv_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each row shows a value inside a record and the exact text this tool writes into the cell.`)
};

const ko_to_csv_ref_intro = /** @type {(inputs: To_Csv_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`각 행은 레코드 안의 값과, 이 도구가 칸에 기록하는 정확한 텍스트를 보여줍니다.`)
};

const ja_to_csv_ref_intro = /** @type {(inputs: To_Csv_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各行はレコード内の値と、このツールがセルに書き込む正確なテキストを示します。`)
};

/**
* | output |
* | --- |
* | "Each row shows a value inside a record and the exact text this tool writes into the cell." |
*
* @param {To_Csv_Ref_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_ref_intro = /** @type {((inputs?: To_Csv_Ref_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Ref_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_ref_intro(inputs)
	if (locale === "ko") return ko_to_csv_ref_intro(inputs)
	return ja_to_csv_ref_intro(inputs)
});